import config from "@/lib/config";
import routes from "@/lib/routes";
import MetaTags from "./index";

export function tags(keyword, mode) {
  if (mode === "channel") {
    return {
      title: `${keyword}の動画配信 - 月額動画配信 | スカパー！動画ストア`,
      keywords: "スカパー！動画ストア,動画配信,見放題,レンタル,スカパー！",
      description: `月額商品にある${keyword}の検索結果。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "channel")}`,
      },
    };
  } else if (mode === "store") {
    return {
      title: `${keyword}の動画配信 - 単品商品 | スカパー！動画ストア`,
      keywords: "スカパー！動画ストア,動画配信,レンタル,スカパー！",
      description: `単品商品にある${keyword}の検索結果。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "store")}`,
      },
    };
  } else {
    return {
      title: `${keyword}の動画配信 | スカパー！動画ストア`,
      keywords: "スカパー！動画ストア,動画配信,レンタル,スカパー！",
      description: `${keyword}の検索結果。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword)}`,
      },
    };
  }
}

export default function SearchPageMetaTags({ keyword, mode }) {
  const props = tags(keyword, mode);

  return <MetaTags {...props} />;
}
